import { FC, useContext } from 'react';
import { Box } from '@chakra-ui/react';
import { ParagraphFarmFarmCategoriesFragment } from '../../../generated/types';
import { FarmContext } from '../../../context/FarmContext';
import { FarmCategoryListGrouped } from '../../Node/Farm/FarmCategoryListGrouped';

interface FarmFarmCategoriesProps {
  data: ParagraphFarmFarmCategoriesFragment;
}

export const FarmFarmCategories: FC<FarmFarmCategoriesProps> = ({ data }) => {
  const farmContext = useContext(FarmContext);

  if (!farmContext.farm?.categories?.length) return null;

  return (
    <FarmCategoryListGrouped
      categories={farmContext.farm.categories}
      categoryIds={data.categories.map((category) => category.id)}
    />
  );
};
